import { render, staticRenderFns } from "./modifyaccount.vue?vue&type=template&id=f91f374e"
import script from "./modifyaccount.vue?vue&type=script&lang=js"
export * from "./modifyaccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports